// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file artifacts/store/v1/store_service.proto (package artifacts.store.v1, syntax proto3)
/* eslint-disable */

import { ArtifactStoreService } from "./store_service_pb";

/**
 * @generated from rpc artifacts.store.v1.ArtifactStoreService.GetArtifactRevisionPreviewUrl
 */
export const getArtifactRevisionPreviewUrl = ArtifactStoreService.method.getArtifactRevisionPreviewUrl;

/**
 * @generated from rpc artifacts.store.v1.ArtifactStoreService.GetArtifactRevisionDownloadUrl
 */
export const getArtifactRevisionDownloadUrl = ArtifactStoreService.method.getArtifactRevisionDownloadUrl;

/**
 * @generated from rpc artifacts.store.v1.ArtifactStoreService.GetArtifactRevision
 */
export const getArtifactRevision = ArtifactStoreService.method.getArtifactRevision;

/**
 * @generated from rpc artifacts.store.v1.ArtifactStoreService.UploadArtifactRevision
 */
export const uploadArtifactRevision = ArtifactStoreService.method.uploadArtifactRevision;

/**
 * @generated from rpc artifacts.store.v1.ArtifactStoreService.UpdateArtifactSubcategory
 */
export const updateArtifactSubcategory = ArtifactStoreService.method.updateArtifactSubcategory;

/**
 * @generated from rpc artifacts.store.v1.ArtifactStoreService.SetArtifactMisclassification
 */
export const setArtifactMisclassification = ArtifactStoreService.method.setArtifactMisclassification;
